import 'Assets/styles/default/pages/concierge/ManageConciergeSolicitationStyles.less';
import React, { useEffect } from 'react';
import { Typography, VertBreadcrumb, VertButton, VertContainer, VertIcon, VertLoading, notification } from '@vertem-core/vertice-ds';
import { RightOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { Col, Row } from 'antd';
import { ActionEnum, ActionEnumDescription } from './enum/action-enum';
import { useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { resetDataApproveSolicitation } from 'redux/Reducers/Concierge/approveQuotationSlicer';
import { resetDataCancelSolicitation } from 'redux/Reducers/Concierge/cancelQuotationSlicer';
import { getManageSolicitationThunk } from 'redux/Reducers/Concierge/getManageSolicitationSlicer';
import { conciergeLoginThunk } from 'redux/Reducers/Concierge/conciergeLoginSlicer';
import { resetDataReopenSolicitation } from 'redux/Reducers/Concierge/reopenSolicitationSlicer';
import { resetDataRejectQuotation } from 'redux/Reducers/Concierge/rejectQuotationSlicer';
import { getPointsThunk } from 'redux/Reducers/Concierge/getPointsSlicer';
import ErrorApiModal from 'components/Concierge/Modals/ErrorApiModal';
import ManageConciergeDetailsTable from 'components/Concierge/Components/ManageConciergeDetailsTable';
import ManageConciergeAddress from 'components/Concierge/Components/ManageConciergeAddress';
import ManageConciergeActionHistory from 'components/Concierge/Components/ManageConciergeActionHistory';
import ManageConciergeItemsTable from 'components/Concierge/Components/ManageConciergeItemsTable';
import QuotationApprovalModal from 'components/Concierge/Modals/QuotationApprovalModal';
import { resetApproveProposedQuotationData } from 'redux/Reducers/Concierge/approveProposedQuotation';
import { resetApproveSolicitationWithTermData } from 'redux/Reducers/Concierge/approveQuotationWithTerm';
import ReopenSolicitationModal from 'components/Concierge/Modals/ReopenSolicitationModal';
import RejectQuotationModal from 'components/Concierge/Modals/RejectQuotationModal';
import CancelSolicitationModal from 'components/Concierge/Modals/CancelSolicitationModal';
import StepApprovalModal from 'components/Concierge/Modals/StepApprovalModal';
import { SolicitationDetailsInitialState } from 'Constants/Concierge/initialStateValues';
import ConciergeProvider from 'components/Checkout/CheckoutProvider';
import { useCheckoutProvider } from 'components/Checkout/CheckoutProvider';
import { CheckoutModal2FA as Modal2FA } from 'components/2FA/CheckoutModal2FA';
import OnboardingRedirectModal from 'components/Onboarding/OnboardingRedirectModal';
import { RegisterSteps } from 'pages/NewConciergeSolicitationPage/enum/new-solicitation-enum';

const ManageConciergeSolicitationPage = () => {
    const [showModalErrorLogin, setShowModalErrorLogin] = useState(false);

    const [solicitation, setSolicitation] = useState(SolicitationDetailsInitialState);
    const [listQuotationItemId, setListQuotationItemId] = useState([]);
    const [selectedQuotation, setSelectedQuotation] = useState('');

    const [showQuotationApproval, setShowQuotationApproval] = useState(false);
    const [showStepApprovalModal, setShowStepApprovalModal] = useState(false);
    const [showCancelSolicitationModal, setShowCancelSolicitationModal] = useState(false);
    const [showReopenSolicitationModal, setShowReopenSolicitationModal] = useState(false);
    const [showRejectQuotationModal, setShowRejectQuotationModal] = useState(false);

    const [isQuotationApprovalWithTerm, setIsQuotationApprovalWithTerm] = useState(false);
    const [isStepApprovalWithTerm, setIsStepApprovalWithTerm] = useState(false);

    const { handleRemoveErrors, errors } = useCheckoutProvider();
    const [validation2FA, setValidation2FA] = React.useState(null);
    const [showOnboardingModal, setShowOnboardingModal] = useState(false);
    const [response2FA, setResponse2FA] = useState(false);

    const { id } = useParams();

    const {
        dataGetManageSolicitation,
        loadingGetManageSolicitation,
        errorGetManageSolicitation,
    } = useSelector(
        (state) => state.GetManageSolicitation
    );

    const {
        dataConciergeLogin,
        errorConciergeLogin,
    } = useSelector(
        (state) => state.ConciergeLogin
    );

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [hasAddress, setHasAddress] = useState(true);
    const [hasSupplier, setHasSupplier] = useState(true);

    const isQuotationApproval = () => {
        if (!solicitation.approvedQuotation && solicitation.quotations.length > 0) return true;

        return false;
    }

    const stepBeforeRedemption = solicitation.actionHistory.stepBeforeRedemption;

    const getApproveButtonLabel = (withTerm) => {
        const approveButtonLbl = stepBeforeRedemption ? ActionEnumDescription.ApproveRedemption : ActionEnumDescription.ApproveQuotation;
        if (isQuotationApproval()) {
            if (withTerm) return ActionEnumDescription.ApproveQuotationWithTerm;
            return approveButtonLbl;
        }

        if (withTerm) return ActionEnumDescription.ApproveWithTerms;

        return approveButtonLbl;
    }

    const wrapperActionButton = (action) => {
        var labelButton = "";
        var typeButton = "default";
        var callback = null;
        var disableCondition = false;

        switch (action) {
            case ActionEnum.Approve:
                labelButton = getApproveButtonLabel();
                callback = approveStep;
                typeButton = "highlight";
                disableCondition = approveButtonDisabled();
                break;

            case ActionEnum.ApproveWithTerms:
                labelButton = getApproveButtonLabel(true);
                callback = approveStepWithTerm;
                typeButton = "highlight";
                disableCondition = approveButtonDisabled();
                break;

            case ActionEnum.Cancel:
                labelButton = ActionEnumDescription.Cancel;
                callback = cancelSolicitation;
                break;

            case ActionEnum.Edit:
                labelButton = ActionEnumDescription.Edit;
                callback = editSolicitation;
                break;

            case ActionEnum.Reopen:
                labelButton = ActionEnumDescription.Reopen;
                callback = reopenSolicitation;
                break;

            case ActionEnum.RejectQuotation:
                labelButton = ActionEnumDescription.RejectQuotation;
                callback = rejectQuotation;
                break;
        }

        return (
            <VertButton
                type={typeButton}
                size="default"
                className={`button-concierge`}
                onClick={callback}
                disabled={disableCondition}
            >
                {labelButton}
            </VertButton>
        )
    }

    const approveButtonDisabled = () => {
        if (isQuotationApproval() && !selectedQuotation)
            return true;

        if (isQuotationApproval() && listQuotationItemId.length === 0)
            return true;

        return false;
    }

    const approveStep = () => {
        if (isQuotationApproval()) {
            setIsQuotationApprovalWithTerm(false);
            setShowQuotationApproval(true);

            return;
        }

        setIsStepApprovalWithTerm(false);
        setShowStepApprovalModal(true);
    }

    const approveStepWithTerm = () => {
        if (isQuotationApproval()) {
            setIsQuotationApprovalWithTerm(true);
            setShowQuotationApproval(true);

            return;
        }

        setIsStepApprovalWithTerm(true);
        setShowStepApprovalModal(true);
    }

    const cancelSolicitation = () => {
        setShowCancelSolicitationModal(true);
    }

    const reopenSolicitation = () => {
        setShowReopenSolicitationModal(true);
    }

    const rejectQuotation = () => {
        setShowRejectQuotationModal(true);
    }

    const editSolicitation = () => {
        navigate(`/new-solicitation/${id}`);
    }

    useEffect(() => {
        const steps = solicitation?.redemptionWorkflow?.registerSteps || [];
        const hasAddresses = !steps.length || steps.some(item => item.step === RegisterSteps.SelectAddress);
        const hasSuppliers = !steps.length || steps.some(item => item.step === RegisterSteps.SelectSupplier);

        setHasAddress(hasAddresses);
        setHasSupplier(hasSuppliers);

    }, [solicitation]);

    useEffect(() => {
        if (!dataGetManageSolicitation.details.id) {
            return;
        }
        setSolicitation(dataGetManageSolicitation);
        if (dataGetManageSolicitation.quotations.length) {
            setSelectedQuotation(dataGetManageSolicitation.quotations[0].id);
        }
    }, [dataGetManageSolicitation]);

    useEffect(() => {
        if (errorConciergeLogin) {
            setShowModalErrorLogin(true);
        }
    }, [errorConciergeLogin]);

    useEffect(() => {
        if (dataConciergeLogin) {
            dispatch(getManageSolicitationThunk(id));
        }
    }, [dataConciergeLogin]);

    useEffect(() => {
        if (!errors) return;

        const error = errors['concierge2FA'];
        if (error) {
            notification.error({
                message: error.title,
                description: error.message,
                duration: 10
            });
        }
    }, [errors]);

    useEffect(() => {
        if (!response2FA) return;

        const metadata = response2FA?.responseData.metadata;

        if (!metadata?.OrderStatus) {
            notification.error({
                message: 'Houve um erro ao aprovar etapa: OrderStatus não identificado'
            });
            return;
        }

        switch (metadata.OrderStatus?.toUpperCase()) {
            case 'AUTHENTICATIONREQUIRED':
            case 'REQUIRESTOKENVALIDATION':
                const validation2FA = {
                    orderId: metadata.OrderId,
                    orderStatus: 'AuthenticationRequired',
                    data: response2FA.requestData
                };
                handleRemoveErrors('concierge2FA');
                setValidation2FA(validation2FA);
                break;

            case 'ONBOARDINGREQUIRED':
            case 'MESSAGEONBOARDINGREQUIRED':
                setShowOnboardingModal(true);
                break;

            default:
                notification.error({
                    message: `Houve um erro ao aprovar etapa: ${metadata.OrderStatus}`
                });
                return;
        }

        setShowQuotationApproval(false);
        setShowStepApprovalModal(false);

    }, [response2FA]);

    useEffect(() => {
        dispatch(conciergeLoginThunk());
        dispatch(getPointsThunk());
    }, []);

    return (
        <VertContainer spacingX="regular" spacingY="regular">
            <VertBreadcrumb
                hasBackButton={true}
                separator={<VertIcon component={RightOutlined} />}
                items={[
                    {
                        title: 'Início',
                        path: '/',
                    },
                    {
                        title: 'Solicitação de produtos e serviços',
                        path: '/list-solicitations',
                    },
                    {
                        title: "Gerenciar solicitação",
                        path: `/manage-solicitation/${id}`
                    }
                ]}
            />

            <Col className="container-title-main" span={20}>
                <Typography.Text className="text-title">
                    Gerenciar Solicitação
                </Typography.Text>
            </Col>

            {
                loadingGetManageSolicitation ? (
                    <Row justify="center">
                        <VertLoading />
                    </Row>
                ) : (
                    <>
                        <ManageConciergeDetailsTable listConcierge={[solicitation?.details]} />

                        {hasAddress &&
                            <ManageConciergeAddress addresses={solicitation?.addresses} />
                        }

                        <ManageConciergeActionHistory actionHistory={solicitation?.actionHistory} />

                        <ManageConciergeItemsTable
                            solicitation={solicitation}
                            selectedQuotation={selectedQuotation}
                            listSelectedQuotationId={listQuotationItemId}
                            setSelectedQuotation={setSelectedQuotation}
                            setListSelectedQuotationId={setListQuotationItemId}
                            hasSupplier={hasSupplier}
                        />
                    </>
                )
            }

            <Row gutter={[0, { xs: 8, sm: 8 }]} justify={'end'} className='margin-top-big'>
                <Col className='custom-col'>
                    <Row align={'middle'} justify={'center'} gutter={[8, 8]}>
                        {
                            [...solicitation?.actions].sort((a, b) => b - a).map(action => (
                                <Col className='custom-col'>
                                    {wrapperActionButton(action)}
                                </Col>
                            ))
                        }
                    </Row>
                </Col>
            </Row>

            <QuotationApprovalModal
                isOpen={showQuotationApproval}
                setIsOpen={setShowQuotationApproval}
                step={solicitation.details.statusDescription}
                stepBeforeRedemption={stepBeforeRedemption}
                withTerm={isQuotationApprovalWithTerm}
                solicitationId={solicitation.details.id}
                quotationId={selectedQuotation}
                quotationProductIds={listQuotationItemId}
                setResponse2FA={setResponse2FA}
                onSuccess={(approvalData) => {
                    if (stepBeforeRedemption) {
                        navigate(`/order-details?orderId=${approvalData.orders[0]?.parentOrderId}&fromCheckout=true`)
                        return;
                    }
                    dispatch(resetApproveProposedQuotationData());
                    dispatch(getManageSolicitationThunk(id));
                }}
            />

            <StepApprovalModal
                isOpen={showStepApprovalModal}
                setIsOpen={setShowStepApprovalModal}
                solicitationId={solicitation.details.id}
                step={solicitation.details.statusDescription}
                withTerm={isStepApprovalWithTerm}
                setResponse2FA={setResponse2FA}
                stepBeforeRedemption={stepBeforeRedemption}
                onSuccess={(approvalData) => {
                    if (stepBeforeRedemption) {
                        navigate(`/order-details?orderId=${approvalData.orders[0]?.parentOrderId}&fromCheckout=true`)
                        return;
                    }
                    dispatch(resetDataApproveSolicitation());
                    dispatch(resetApproveSolicitationWithTermData());
                    dispatch(getManageSolicitationThunk(id));
                }}
            />

            <CancelSolicitationModal
                isOpen={showCancelSolicitationModal}
                setIsOpen={setShowCancelSolicitationModal}
                solicitationId={solicitation.details.id}
                stepBeforeRedemption={stepBeforeRedemption}
                onSuccess={() => {
                    dispatch(resetDataCancelSolicitation());
                    dispatch(getManageSolicitationThunk(id));
                }}
            />

            <RejectQuotationModal
                isOpen={showRejectQuotationModal}
                setIsOpen={setShowRejectQuotationModal}
                solicitationId={solicitation.details.id}
                onSuccess={() => {
                    dispatch(resetDataRejectQuotation());
                    dispatch(getManageSolicitationThunk(id));
                }}
            />

            <ReopenSolicitationModal
                isOpen={showReopenSolicitationModal}
                setIsOpen={setShowReopenSolicitationModal}
                solicitationId={solicitation.details.id}
                onSuccess={() => {
                    dispatch(resetDataReopenSolicitation());
                    dispatch(getManageSolicitationThunk(id));
                }}
            />

            <ErrorApiModal
                isOpen={errorGetManageSolicitation}
                onClose={() => navigate("/list-solicitations")}
                subtitle="Não foi possível carregar as informações da Solicitação informada, você será redirecionado a listagem."
            />

            <ErrorApiModal
                isOpen={showModalErrorLogin}
                onClose={() => navigate("/auth/logout")}
                subtitle="Será necessário realizar o login novamente!"
            />

            <Modal2FA
                propsServiceName={'CONCIERGE'}
                propsOrderId={validation2FA?.orderId}
                propsStatus={validation2FA?.orderStatus}
                purchaseData={validation2FA?.data}
            />

            <OnboardingRedirectModal
                open={showOnboardingModal}
                handleClose={() => setShowOnboardingModal(false)}
            />
        </VertContainer>
    )
}

export default (props) => (<>
    <ConciergeProvider>
        <ManageConciergeSolicitationPage {...props} />
    </ConciergeProvider>
</>);

